import circularJSON from 'circular-json';

import { toParameterString, fixedFetch } from '../utils';
import { config as cognito } from '../redux/sagas/aws-cognito-redux-saga';

const makeGETRequest = url =>
  fixedFetch(url, {
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: {
      'content-type': 'text/plain',
    },
    method: 'GET',
    mode: 'cors',
    referrer: 'no-referrer',
  });

const makeAuthenticatedGETRequest = async url => {
  await cognito.getCredentials();
  const token = await cognito.getSession();
  return fixedFetch(url, {
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json',
      Authorization: token.idToken.jwtToken,
    },
    method: 'GET',
    mode: 'cors',
    referrer: 'no-referrer',
  });
};

const makePOSTRequest = (url, body) =>
  fixedFetch(url, {
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify(body),
    mode: 'cors',
    method: 'POST',
    referrer: 'no-referrer',
  });

const makeAuthPOSTRequest = async (url, body) => {
  await cognito.getCredentials();
  const token = await cognito.getSession();
  return fixedFetch(url, {
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json',
      Authorization: token.idToken.jwtToken,
    },
    body: JSON.stringify(body),
    mode: 'cors',
    method: 'POST',
    referrer: 'no-referrer',
  });
};

const makePUTRequest = async (url, body) =>
  fixedFetch(url, {
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json'
    },
    body: JSON.stringify(body),
    mode: 'cors',
    method: 'PUT',
    referrer: 'no-referrer',
  });
const makeAuthPUTRequest = async (url, body) => {
  await cognito.getCredentials();
  const token = await cognito.getSession();
  return fixedFetch(url, {
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json',
      Authorization: token.idToken.jwtToken,
    },
    body: JSON.stringify(body),
    mode: 'cors',
    method: 'PUT',
    referrer: 'no-referrer',
  });
};

export const getContent = params =>
  makeGETRequest(`/api/content?${toParameterString(params)}`).then(response => {
    const data = circularJSON.parse(response);
    if (data.status && data.status !== 200) {
      throw data;
    }
    return data;
  });

export const fetchContent = params =>
  makeGETRequest(`/api/content?${toParameterString(params)}`).then(response => {
    const data = circularJSON.parse(response);
    if (data.status && data.status !== 200) {
      throw data;
    }
    return { data, locale: params.locale };
  });

export const saveUserInfoToDB = data => {
  const { email, diagnosisResults, locale } = data;
  return makePOSTRequest(`/api/profile`, {
    email,
    locale,
    diagnosisResult: diagnosisResults[0],
  }).then(response => {
    if (response.status && response.status !== 200) {
      throw response;
    }
    return response;
  });
};

export const getUserDiagnosis = id =>
  makeGETRequest(`/api/profile/${id}`).then(response => {
    if (response.status && response.status !== 200) {
      throw response;
    }
    return response;
  });
export const getSCUserDiagnosis = id =>
  makeGETRequest(`/api/sc/profiles/${id}/email`).then(response => {
    if (response.status && response.status !== 200) {
      throw response;
    }
    return response;
  });

export const getUserDiagnosisByEmail = email => {
  const params = toParameterString({ email });
  return makeGETRequest(`/api/profile?${params}`).then(response => {
    if (response.status && response.status !== 200) {
      throw response;
    }
    return response;
  });
};

export const saveNewSalonVisitToDB = userInfo =>
  makePOSTRequest(`/api/profile/${userInfo.hash}/salon_visit`, userInfo.salonVisit).then(response => {
    if (response.status && response.status !== 200) {
      throw response;
    }
    return response;
  });

export const sendCustomerEmail = id =>
  makePOSTRequest(`/api/profile/${id}/email`).then(response => {
    if (response.status && response.status !== 200) {
      throw response;
    }
    return response;
  });

export const fetchUserService = username => {
  const params = toParameterString({ username });
  return makeAuthenticatedGETRequest(`/api/user?${params}`).then(response => {
    if (response.status && response.status !== 200) {
      throw response;
    }
    return response;
  });
};

export const sendSalonInfoUpdateEmail = params =>
  makePUTRequest(`/api/salon`, params).then(response => {
    if (response.status && response.status !== 200) {
      throw response;
    }
    return response;
  });

export const sendCustomerEmailHash = hash =>
  makeAuthenticatedGETRequest(`/api/sc/profiles/${hash}/email`).then(response => {
    if (response.status && response.status !== 200) {
      throw response;
    }
    return response;
  });

export const saveCustomerProfile = params =>
  makeAuthPUTRequest(`/api/sc/profiles`, params).then(response => {
    if (response.status && response.status !== 200) {
      throw response;
    }
    return response;
  });

export const saveCustomerProfileAndSendEmail = params =>
  makePUTRequest(`/api/sc/profiles/email`, params).then(response => {
    if (response.status && response.status !== 200) {
      throw response;
    }
    return response;
  });

export const saveNewCustomerProfile = params =>
  makeAuthPOSTRequest(`/api/sc/profiles`, params).then(response => {
    if (response.status && response.status !== 200) {
      throw response;
    }
    return response;
  });

export const getCustomerProfile = params =>
  makeAuthenticatedGETRequest(`/api/sc/profiles?${toParameterString(params)}`).then(response => {
    if (response.status && response.status !== 200) {
      throw response;
    }
    return response;
  });

export const getSalonVisits = params =>
  makeAuthenticatedGETRequest(`/api/sc/salonVisits?${toParameterString(params)}`).then(response => {
    if (response.status && response.status !== 200) {
      throw response;
    }
    return response;
  });

export const saveSalonVisitsToDB = salonVisit => {
  return makeAuthPOSTRequest(`/api/sc/salonVisits`, salonVisit).then(response => {
  if (response.status && response.status !== 200) {
      throw response;
    }
    return response;
  });
};
export const updateSalonVisitsToDB = salonVisit => {
  return makeAuthPUTRequest(`/api/sc/salonVisits`, salonVisit).then(response => {
    if (response.status && response.status !== 200) {
      throw response;
    }
    return response;
  });
};
export const getSpAuthSalonSettings = params =>
  makeAuthenticatedGETRequest(`/api/sc/salonSettings?${toParameterString(params)}`).then(response => {
    if (response.status && response.status !== 200) {
      throw response;
    }
    return response;
  });
export const placeholder = () => {};
export const putSpAuthSalonSettings = params =>
  makeAuthPUTRequest(`/api/sc/salonSettings`, params).then(response => {
    if (response.status && response.status !== 200) {
      throw response;
    }
    return response;
  });

export const getScalpCameraPinCode = type => {
  const body = {
    application: type,
    imageExtension: 'jpg',
  };
  return makeAuthPOSTRequest(`/api/sc/cameraAppResults`, body).then(response => {
    if (response.status && response.status !== 200) {
      throw response;
    }
    return response;
  });
};

export const getScalpCameraResults = pin => {
  const date = new Date();
  const param = { ...pin, t: date.getTime() };
  return makeAuthenticatedGETRequest(`/api/sc/cameraAppResults?${toParameterString(param)}`).then(response => {
    if (response.status && response.status !== 200) {
      throw response;
    }
    return response;
  });
};



// WEBPACK FOOTER //
// ./src/services/api.js